import Backbone from 'backbone';

import { toQueryString } from 'utils/UrlUtil';

const Events = {
    ON_MORE_MEMBERS_FETCHED: 'ON_MORE_MEMBERS_FETCHED'
};

const CursorPagedCollection = Backbone.Collection.extend({
    baseUrl: null,

    url: function() {
        let url = this.getBaseUrl();
        const queryObject = {};
        if (this.verb !== 'POST') {
            if (typeof this.limit === 'number') {
                queryObject['limit'] = this.limit;
            }
            if (typeof this.cursor === 'string') {
                queryObject['cursor'] = this.cursor;
            }
        }

        return `${url}${toQueryString(queryObject)}`;
    },

    getBaseUrl: function() {
        if (typeof this.baseUrl === 'function') {
            return this.baseUrl();
        } else {
            return this.baseUrl;
        }
    },

    /**
     * Initial setup.
     */
    initializeCursorPagedCollection: function(args) {
        this.initialFetchDone = false;
        this.appendMode = true; // When set to true, the returned collection will always contain all models (Every model from every page)
        // When set to false, each fetch will replace the collections models, always returning the <<limit>> number of models (until last page)

        if (args) {
            this.limit = args.limit; // The size of the fetches.
            this.cursor = args.cursor;
            this.shouldSort = args.sort; // When set to false, prevents the added models to be sorted through the collection comparator function. Defaults to true.
        }

        if (args.hasOwnProperty('appendMode')) {
            this.appendMode = args.appendMode;
        }

        this.verb = args.verb;
        if (!this.verb) {
            this.verb = 'POST';
        }

        if (typeof this.shouldSort !== 'boolean') {
            this.shouldSort = true;
        }
    },

    /**
     * Simply calls fetch. The starting position and limit are managed internally. This function is provided mostly
     * to provide clarity for the API.
     */
    fetchNext: function(fetchOptions) {
        fetchOptions = fetchOptions || {};

        let successCallback = null;
        if (fetchOptions.success) {
            successCallback = fetchOptions.success;
        }

        if (this.appendMode) {
            fetchOptions.add = true;
            fetchOptions.remove = false;
        }

        fetchOptions.type = this.verb;
        fetchOptions.sort = this.shouldSort;

        if (this.verb === 'POST') {
            let data = {};
            data.limit = this.limit;
            fetchOptions.data = data;
            fetchOptions.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        }

        let _this = this;
        fetchOptions.success = function(collection, response, options) {
            _this.onFetchSuccess(collection, response, options);

            if (successCallback) {
                successCallback.call(_this, collection, response, options);
            }
        };

        if (this.hasMoreMembers()) {
            Backbone.Collection.prototype.fetch.call(this, fetchOptions);
        }
    },

    /**
     * Overloaded version of fetch which calls the FetchNext instead. FetchNext will then call the base version
     * of fetch. This prevents callers from circumventing the housekeeping in the FetchNext() function.
     */
    fetch: function(options) {
        this.fetchNext(options);
    },

    /**
     * Handler called when a fetch has been completed.
     */
    onFetchSuccess: function(collection, response, options) {
        // update the cursor from API response
        this.cursor = response.pagination.nextCursor;
        this.trigger(Events.ON_MORE_MEMBERS_FETCHED);
        if (!this.initialFetchDone) this.initialFetchDone = true;
    },

    /**
     * Returns whether or not there are more members to fetch.
     */
    hasMoreMembers: function() {
        return !this.initialFetchDone || this.cursor !== null;
    }
});

CursorPagedCollection.Events = Events;

export default CursorPagedCollection;
